package com.wintermar.inspection.feature.presentation.inspection.widget

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.style.TextOverflow
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import com.wintermar.inspection.feature.domain.model.answer.AnswerModel
import com.wintermar.inspection.feature.domain.model.template.TemplateOptionModel
import com.wintermar.inspection.graphql.type.FindingCategory
import com.wintermar.inspection.graphql.type.InspectionAnswerType

@Composable
fun AnswerDetailView(
    question: String,
    answer: AnswerModel,
    answerType: InspectionAnswerType,
    templateOptions: List<TemplateOptionModel>,
    page: String,
    hidePage: Boolean = false
) {
    val color: ThemeColor = LocalAppTheme.current.color
    val dimension: AppDimension = LocalAppTheme.current.dimension

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(dimension.radius.lg))
            .background(color.surface.normal)
            .padding(
                dimension.spacing.space3
            ),
        verticalArrangement = Arrangement.spacedBy(
            space = dimension.spacing.space3
        )
    ) {
        if (!hidePage) {
            TextBodySmall(
                text = page.trim(),
                color = { it.subtle },
                maxLines = 2,
                overflow = TextOverflow.Ellipsis
            )
        }

        TextBodySmall(
            text = question,
            bold = true
        )

        AnswerChooseView(
            answerType = answerType,
            answerOptionId = answer.answerOptionId,
            templateOptions = templateOptions
        )

        if (answer.notes.isNotEmpty() || answer.files.isNotEmpty() || answer.findingCategory != null) {
            NotesPhotoView(
                notes = answer.notes,
                files = answer.files,
                showFindingCategory = answer.isRequiredFileOrNotes && !answer.isEmptyFindingCategory(),
                findingCategory = answer.findingCategory ?: FindingCategory.UNKNOWN__
            )
        }
    }
}
